<template>
	<div v-if="histories.length !== 0" class="block">
		<h2 class="heading2">閲覧履歴</h2>
		<ul class="linkList">
			<li v-for="item in histories">
				<a v-link="{path: '/detail/' + item.id}" target="_self">
					<div class="flexColumn">
						<div class="flexColumn__col1">
							<img v-bind:src="item.thumbnail" class="img-responsive" alt="">
						</div>
						<div class="flexColumn__col2">
							<h4 v-text="item.name" class="heading3"></h4>
							<!-- <p v-text="item.promoword" class="pr"></p> -->
						</div>
					</div>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
module.exports = {
	route: {
		data: function(transition){
		},
		canReuse: false
	},
	data: function(){
		return {
			histories: [],
			reload: {
				times: 3,
				delay: 5000
			}
		};
	},
	created: function() {
		this.getHistories();

		// レシーブ
		this.$on('resLeaveDetail', function(){
			// console.log('resLeaveDetail');
			this.getHistories();
		});
	},
	ready: function(){
	},
	methods: {
		devMode: function(){
			return this.$route.devmode;
		},
		createJsonPath: function(profile_id){
			var devmode = this.devMode();
			var host = (document.location.protocol === 'https:') ? 'https:' : 'http:';
			var hostname = document.location.hostname;
			var apipath = host + '//' + hostname + '/s/api/';
			var url = devmode ? '/static/json/sample_detail.json' : apipath + 'profile/' + profile_id;
			return url;
		},
		getJson: function(url, index = '', times = this.reload.times, delay = this.reload.delay){
			var devmode = this.devMode();
			this.$http.get(url).then(function (response) {
				// success callback
				var json = response.data;
				// console.log(json.Profiles.img_1);
				var dataObj = null;

				if (json.length !== 0 && Object.keys(json).length !== 0){
					var thumbFileName = '';
					if (json.Profiles.img_1){
						var imgDir = devmode ? '/static/images/sample_studio/' : '/s/img/studio/';
						thumbFileName = imgDir + json.Profiles.img_1.replace(/^(.+)(\.[a-z]+)$/, '$1_thumbnail$2');
					} else {
						thumbFileName = '/static/images/thumb/no_image_r.jpg';
					}

					dataObj = {
						id: json.Profiles.id,
						name: json.Profiles.name,
						promoword: json.Profiles.promoword,
						thumbnail: thumbFileName
					};
				}

				if (index !== ''){
					this.histories.$set(index, dataObj);
				} else {
					this.histories.unshift(dataObj);
				}
				// console.log(this.histories);
			}, function (response) {
				// error callback
				console.log(response.status);
				console.log('データの取得に失敗しました');
				if (times > 0){
					setTimeout(this.getJson, delay, url, index, times - 1, delay);
				}
			});
		},
		getHistories: function(){
			var item = window.localStorage.getItem('history');
			var historyArr = item ? JSON.parse(item) : [];
			for (var i = 0; i < historyArr.length; i++){
				var url = this.createJsonPath(historyArr[i]);
				this.getJson(url, i);
			}
		}
	}
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// widget_history.vue?966c18ee